import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SEOHelmet, {
  siteUrl,
  blogListSchema,
  buildBreadcrumb,
} from "../components/SEOHelmet";
import blogsData from "../data/blogs.json";

const Blogs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);

  const itemsPerPage = 6;

  const filteredBlogs = blogsData.filter((blog) => {
    const matchCategory = selectedCategory ? blog.category === selectedCategory : true;
    const matchTag = selectedTag ? blog.tags.includes(selectedTag) : true;
    return matchCategory && matchTag;
  });

  const totalPages = Math.ceil(filteredBlogs.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedBlogs = filteredBlogs.slice(startIndex, startIndex + itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory, selectedTag]);

  const categoriesWithCounts = blogsData.reduce((acc, blog) => {
    acc[blog.category] = (acc[blog.category] || 0) + 1;
    return acc;
  }, {});

  const popularTags = Array.from(
    new Set(blogsData.flatMap((blog) => blog.tags))
  ).slice(0, 10);

  const recentBlogs = blogsData.slice(0, 8);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCategorySelect = (category) => {
    if (selectedCategory === category) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
      setSelectedTag(null);
    }
  };

  const handleTagSelect = (tag) => {
    if (selectedTag === tag) {
      setSelectedTag(null);
    } else {
      setSelectedTag(tag);
      setSelectedCategory(null);
    }
  };


  return (
    <>
      <SEOHelmet
        title="Photography Blog | Baby & Newborn Photography Tips – Hyderabad"
        description="Read Baby Twinkles Photography's blog for expert tips on newborn safety, baby milestone sessions, cake smash ideas, maternity photography styling, and preparing for your baby photoshoot in Madhapur, Hyderabad, Telangana."
        keywords="baby photography blog, newborn photography tips Hyderabad, how to prepare for baby photoshoot, baby milestone photography ideas, cake smash tips Hyderabad, maternity photography tips, baby photography inspiration Hyderabad, newborn photography ideas India, baby photography blog India"
        canonicalUrl={`${siteUrl}/blogs`}
        ogType="website"
        schema={[
          blogListSchema,
          buildBreadcrumb([
            { name: "Home", url: `${siteUrl}/` },
            { name: "Blog", url: `${siteUrl}/blogs` },
          ]),
        ]}
      />
      <div className="inner-page-banner" data-aos="fade-down">
        <div className="banner-wrapper">
          <div className="container-fluid">
            <div className="banner-main-content-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="banner-content">
                    <ul className="breadcrumb-list mt-5 pt-5 d-flex justify-content-center align-items-center">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>Blogs</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blog-standard-page mt-4" style={{overflow:"hidden"}}>
        <div className="container">
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-8">
              <div className="news-section five mt-2 mb-md-4 mb-0">
                <div className="row g-4">
                  {paginatedBlogs.length > 0 ? (
                    paginatedBlogs.map((blog, index) => (
                      <div
                        key={blog.id}
                        className="col-lg-6 col-md-6 wow fadeInUp"
                        data-wow-delay={`${200 + (index * 100)}ms`}
                      >
                        <div className="news-card">
                          <div className="news-img" style={{ height: "240px", overflow: "hidden" }}>
                            <Link to={`/blogs/${blog.slug}`}>
                              <img src={blog.image} alt={blog.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            </Link>
                            <div className="date">
                              <button
                                onClick={() => handleCategorySelect(blog.category)}
                                style={{ background: "none", border: "none", color: "inherit", padding: 0, fontWeight: "inherit", fontSize: "inherit" }}
                              >
                                {blog.category}
                              </button>
                            </div>
                          </div>
                          <div className="content">
                            <h6>
                              <Link to={`/blogs/${blog.slug}`}>
                                {blog.title}
                              </Link>
                            </h6>
                            <div className="news-btm">
                              <div className="author-area">
                                <div className="author-img bg-dark" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "4px", borderRadius: "50%", width: "40px", height: "40px", overflow: "hidden" }}>
                                  <img src="/assets/img/logo.png" alt="Baby Twinkles" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                </div>
                                <div className="author-content">
                                  <h6>Baby Twinkles</h6>
                                  <Link to={`/blogs/${blog.slug}`}>
                                    Posted on - {blog.date}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center py-5">
                      <h4 className="text-muted">No blog posts found matching the criteria.</h4>
                    </div>
                  )}
                </div>

                {totalPages > 1 && (
                  <div className="row mt-5">
                    <div className="col-12 d-flex justify-content-center">
                      <nav className="pagination-wrapper">
                        <div className="pagination d-flex gap-2 align-items-center">
                          <button
                            className={`btn pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                              padding: "4px 10px",
                              borderRadius: "8px",
                              border: "1px solid #dee2e6",
                              background: currentPage === 1 ? "#f8f9fa" : "#fff",
                              color: "#7c3aed",
                              fontWeight: "500"
                            }}
                          >
                            ← 
                          </button>
                          {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                            <button
                              key={pageNumber}
                              className={`btn pagination-page-btn ${currentPage === pageNumber ? "active" : ""}`}
                              onClick={() => handlePageChange(pageNumber)}
                              style={{
                                padding: "4px 10px",
                                borderRadius: "8px",
                                border: currentPage === pageNumber ? "none" : "1px solid #dee2e6",
                                background: currentPage === pageNumber ? "#7c3aed" : "#fff",
                                color: currentPage === pageNumber ? "#fff" : "#333",
                                fontWeight: currentPage === pageNumber ? "600" : "400",
                                minWidth: "40px"
                              }}
                            >
                              {pageNumber}
                            </button>
                          ))}
                          <button
                            className={`btn pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{
                              padding: "4px 10px",
                              borderRadius: "8px",
                              border: "1px solid #dee2e6",
                              background: currentPage === totalPages ? "#f8f9fa" : "#fff",
                              color: "#7c3aed",
                              fontWeight: "500"
                            }}
                          >
                          →
                          </button>
                        </div>
                      </nav>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="blog-sidebar mb-4">
                <div className="single-widgets widget_egns_categoris mb-20">
                  <div className="widget-title mb-20">
                    <h6>Category</h6>
                  </div>
                  <ul className="wp-block-categoris-cloud">
                    {Object.entries(categoriesWithCounts).map(([category, count]) => (
                      <li key={category}>
                        <button
                          onClick={() => handleCategorySelect(category)}
                          className={selectedCategory === category ? "active" : ""}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            width: "100%",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "space-between",
                            color: "inherit"
                          }}
                        >
                          <span>{category}</span>{" "}
                          <span className="number-of-categoris">({count})</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="single-widgets widget_egns_recent_post mb-4">
                  <div className="widget-title blog-title mb-20">
                    <h6>Recent Blog</h6>
                  </div>
                  <div className="recent-post-wraper">
                    <div className="d-flex flex-column gap-3">
                      {recentBlogs.map((blog) => (
                        <div key={blog.id} className="widget-cnt d-flex gap-3 align-items-start">
                          <div className="wi flex-shrink-0">
                            <Link to={`/blogs/${blog.slug}`} style={{ display: "block", borderRadius: "8px", overflow: "hidden" }}>
                              <img
                                src={blog.image}
                                alt={blog.title}
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "8px"
                                }}
                              />
                            </Link>
                          </div>
                          <div className="wc flex-grow-1">
                            <Link className="date" to="/blogs" style={{ fontSize: "12px", color: "#888", textDecoration: "none" }}>
                              {blog.date}
                            </Link>
                            <h6 style={{ fontSize: "14px", margin: "4px 0 0 0", lineHeight: "1.4" }}>
                              <Link to={`/blogs/${blog.slug}`} style={{ textDecoration: "none", color: "#333" }}>
                                {blog.title}
                              </Link>
                            </h6>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
